import React from 'react';
import { observer } from 'mobx-react';
import Spinner from '../../../../global/spinner/spinner';
import { FormField } from '../../../../global/form/form-field/form-field';
import { IntlShape } from 'react-intl';
import { CopyButton } from '../../../../global/copy-button/copy-button';
import DefaultButton from '../../../../global/default-button/default-button';

export interface IEventRegistrationTokenProps {
    createEventRegistrationToken: () => Promise<void>;
    generatingEventRegistrationToken: boolean;
    thirdPartyRegistrationEnabled: boolean;
    eventRegistrationToken: string;
    intl: IntlShape;
}

export const EventRegistrationToken = observer(({
    intl,
    eventRegistrationToken,
    thirdPartyRegistrationEnabled,
    createEventRegistrationToken,
    generatingEventRegistrationToken,
}: IEventRegistrationTokenProps) => {

    if (eventRegistrationToken) return (
        <FormField label={intl.formatMessage({
            id: 'oe.event.eventRegistrationToken',
            defaultMessage: 'Event Registration Token',
            description: 'Label text'
        })}>
            <div className='flex'>
                <input
                    className='oe-form-field__control'
                    disabled
                    readOnly
                    value={eventRegistrationToken}
                    data-test-id='event-registration-token'
                />
                <CopyButton copyValue={eventRegistrationToken} className='m-left-6px' />
            </div>
        </FormField>
    );

    if (generatingEventRegistrationToken) return <Spinner />;

    return thirdPartyRegistrationEnabled
        ? <FormField label={intl.formatMessage({
            id: 'oe.event.eventRegistrationToken',
            defaultMessage: 'Event Registration Token',
            description: 'Label text'
        })}>
            <div className='flex'>
                <DefaultButton
                    text={intl.formatMessage({
                        id: 'oe.event.newEventRegistrationToken',
                        defaultMessage: '+ New Event Registration Token',
                        description: 'Button text'
                    })}
                    disabled={generatingEventRegistrationToken}
                    onClick={createEventRegistrationToken}
                    className='add-line-to-table-btn'
                    modifier={['fat', 'options']}
                    dataTestId='create-event-registration-token'
                />
            </div>
        </FormField>
        : null;
});
